var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0803 22.9835C25.391 26.8748 22.6068 30.5032 22 34.0605C22.1005 42.0856 29.6681 52.0237 38.762 61.1039C47.8079 70.1363 58.2844 79.0538 65.9022 77.8987C69.4818 77.2901 73.1337 74.4843 77.058 70.7678C78.3184 69.5661 78.3177 66.9791 77.0333 65.6964L69.2883 57.9631C67.9522 56.629 65.3616 56.6284 63.6598 57.5293L58.4457 61.3464C55.6631 63.7169 49.8009 57.9004 45.9092 54.0145C42.0265 50.1377 36.1019 44.874 38.5995 41.4728L42.4113 36.2813C43.3 34.5999 43.2998 32.0135 42.0255 30.7412L34.3108 23.038C32.9344 21.6636 30.3437 21.6628 29.0805 22.9838L29.0803 22.9835Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.7918a0cdc242a1fa044e70d5b96d60e8.svg";
export { ForwardRef as ReactComponent };